import {
  hideAddCommentModal,
  hideCountDetailsModal,
  showAddCommentModal,
  showCountDetailsModal,
  showSuccessAlert,
  showViewCommentsModal,
} from "@actions/modals";
import count from "@api/count";
import DownloadButton from "@buttons/DownloadButton";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Grid, Header, Icon, Modal } from "semantic-ui-react";
import { setEditMachineCountModal } from "../../redux/actions/modals";

class CountDetailsModal extends React.Component {
  state = {
    activeRow: { collectionId: 0 },
    downloadLoading: false,
    loadingReport: true,
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.modal.batchId !== prevProps.modal.batchId) {
      this.handleRefresh();
    }
  }

  handleClose = () =>
    this.props.hideCountDetailsModal().then(this.props.modal.onClose);

  onViewCommentsClick = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ loadingComments: true }, () => {
      count
        .getComments(collectionType, batchId)
        .then((comments) =>
          this.setState({ loadingComments: false }, () =>
            this.props.showViewCommentsModal(comments),
          ),
        );
    });
  };

  handleSaveComment = async (comment) => {
    const { collectionId } = this.state.activeRow;
    const { collectionType } = this.props.modal;
    count.addComment(collectionType, collectionId, comment).then((response) => {
      this.props.showSuccessAlert(response, "Success", () =>
        this.props.hideAddCommentModal().then(() => this.handleRefresh()),
      );
    });
  };

  handleRefresh = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ loading: true }, () => {
      count.getBatch(batchId, collectionType).then(
        (response) =>
          this.setState({ loading: false }, () =>
            this.props.showCountDetailsModal(
              { ...response, batchId, collectionType },
              this.props.modal.onClose,
            ),
          ),
        () => this.setState({ loading: false }),
      );
    });
  };

  handleAddComment = () => {
    const { siteDisplay, countDateDisplay } = this.props.modal;
    const { gameName } = this.state.activeRow;
    this.props.showAddCommentModal(
      `${siteDisplay} ${countDateDisplay}`,
      gameName,
      this.handleSaveComment,
    );
  };

  downloadReport = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ loadingReport: true }, () => {
      count.getReportPdf(batchId, collectionType).then(
        (response) =>
          this.setState({ loadingReport: false }, () =>
            handleDownload(response),
          ),
        () => this.setState({ loadingReport: false }),
      );
    });
  };

  downloadExport = () => {
    const { batchId, collectionType } = this.props.modal;
    this.setState({ downloadLoading: true }, () => {
      count.getBatchExport(batchId, collectionType).then(
        (response) =>
          this.setState({ downloadLoading: false }, () =>
            handleDownload(response),
          ),
        () => this.setState({ downloadLoading: false }),
      );
    });
  };

  render() {
    const { headerDef, rowDef, data } = this.props.modal;
    const {
      reportLoading,
      downloadLoading,
      activeRow,
      loading,
      loadingComments,
    } = this.state;
    const { siteDisplay, countDateDisplay } = this.props.modal;

    return (
      <Modal
        open={this.props.modal.open}
        onClose={this.handleClose}
        size="fullscreen"
        className="h-60"
        closeIcon
      >
        <Modal.Header>Count Details</Modal.Header>
        <Modal.Content className="h-100">
          <Grid className="height-100 flex-container">
            <Grid.Row>
              <Grid.Column width="8">
                <Header size="small" className="mb-0_5">
                  {siteDisplay}
                </Header>
                <DownloadButton
                  onClick={this.downloadExport}
                  loading={downloadLoading}
                  className="mr-1"
                />
                Count Date: {countDateDisplay}
              </Grid.Column>
              <Grid.Column width="8" textAlign="right">
                <Button
                  content="Edit Count"
                  color="blue"
                  onClick={() =>
                    this.props.setEditMachineCountModal({
                      activeRow,
                      open: true,
                      callback: this.handleRefresh,
                    })
                  }
                  disabled={!activeRow || !activeRow.optionAllowEdit}
                />
                <Button
                  content="Add Comment"
                  color="teal"
                  onClick={this.handleAddComment}
                  disabled={!activeRow || activeRow.collectionId < 1}
                />
                <Button
                  content="View Comments"
                  color="teal"
                  onClick={this.onViewCommentsClick}
                  loading={loadingComments}
                />
                <Dropdown
                  direction="left"
                  icon={null}
                  trigger={
                    <Button
                      color="teal"
                      loading={reportLoading}
                      icon
                      labelPosition="right"
                    >
                      <Icon name="caret down" /> Reports
                    </Button>
                  }
                >
                  <Dropdown.Menu>
                    <Dropdown.Item
                      text="Machine Count"
                      onClick={this.downloadReport}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column width="16" className="gs-flex-container-vertical">
                <DataGrid
                  headings={headerDef}
                  data={data}
                  fullHeight
                  rowDef={rowDef}
                  onRowClick={(activeRow) => this.setState({ activeRow })}
                  loading={loading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.countDetailsModal,
  };
};

export default connect(mapStateToProps, {
  showSuccessAlert,
  hideAddCommentModal,
  setEditMachineCountModal,
  showAddCommentModal,
  showCountDetailsModal,
  hideCountDetailsModal,
  showViewCommentsModal,
})(CountDetailsModal);
